import { primitives } from '@lexody/design-tokens';

// Mirrors app/lexody-mobile/app/components/Topics/activityTheme.js so packs look the same on both.
export const INTERACTIVE_GAME_TAG_ID = 5;

const { violet, pink, orange, blue, yellow, green } = primitives;

const TILE_PALETTES = [
  { tile: [violet['100'], violet['300']], accent: violet['700'], soft: violet['50'] },
  { tile: [pink['100'], pink['300']], accent: pink['700'], soft: pink['50'] },
  { tile: [orange['100'], orange['300']], accent: orange['700'], soft: orange['50'] },
  { tile: [blue['100'], blue['300']], accent: blue['700'], soft: blue['50'] },
  { tile: [yellow['200'], yellow['500']], accent: yellow['800'], soft: yellow['100'] },
  { tile: [green['50'], green['100']], accent: green['700'], soft: green['50'] },
];

const GAME_GRADIENTS = [
  [violet['700'], violet['600'], pink['600']],
  [pink['600'], orange['500']],
  [blue['600'], violet['600']],
  [green['600'], blue['600']],
];

const EMOJI_KEYWORDS = [
  [/guess who|detective|mystery/i, '🕵️'],
  [/would you rather/i, '🤔'],
  [/gif|movie|film/i, '🎬'],
  [/story/i, '📖'],
  [/food|restaurant|cook|recipe/i, '🍕'],
  [/travel|trip|vacation/i, '✈️'],
  [/music|song/i, '🎵'],
  [/picture|photo|describe|draw/i, '🖼️'],
  [/debate|opinion/i, '🎤'],
  [/role|act/i, '🎭'],
  [/question|about you|interview/i, '❓'],
  [/bingo/i, '🎯'],
  [/match|memory/i, '🧩'],
];

const FALLBACK_EMOJI = ['🎲', '💬', '🧩', '🎯', '🌍', '🎨', '🚀', '🎉'];

function seed(activity) {
  const id = Number(activity && activity.id);
  return Number.isFinite(id) ? Math.abs(id) : 0;
}

export function activityEmoji(activity) {
  const title = (activity && activity.title) || '';
  const match = EMOJI_KEYWORDS.find(([pattern]) => pattern.test(title));
  if (match) return match[1];
  return FALLBACK_EMOJI[seed(activity) % FALLBACK_EMOJI.length];
}

export function tilePalette(index) {
  return TILE_PALETTES[index % TILE_PALETTES.length];
}

export function gameGradient(index) {
  return GAME_GRADIENTS[index % GAME_GRADIENTS.length];
}

export function isInteractiveGame(activity) {
  return (activity.tags || []).some(
    (tag) => tag.id === INTERACTIVE_GAME_TAG_ID || tag.tag_id === INTERACTIVE_GAME_TAG_ID
  );
}

export function levelTags(activity) {
  return (activity.tags || []).filter((tag) => tag.id >= 1 && tag.id <= 4);
}
